import { Map, fromJS } from 'immutable';

// eslint-disable-next-line no-restricted-imports -- pre-existing action-creator apiClient usage; migrate to api/<domain>.js when touched
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, dataTableParamFormatter, genericErrorAction, mapToQueryParams } from '@sophocles/utils';

/* Request Actions */
// starter request
export const REQUEST_TAMPER_SITES = 'REQUEST_TAMPER_SITES';
function requestTamperIssue(tamperIssue_id) {
  return {
    type: REQUEST_TAMPER_SITES,
    tamperIssue_id,
  };
}

/* Fetch Actions */
export function fetchAllTamperIssue(tableParams) {
  return dispatch => {
    dispatch(requestTamperIssue());
    const params = Map().merge(dataTableParamFormatter(tableParams));
    return apiClient
      .get(`/sites/withenclosuretamperissue/?${mapToQueryParams(params)}`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_TAMPER_SITES)));
  };
}
